import { TestBuyFollowUp } from "@coworker/types/lib/tasks/testbuy_followup";
import { useState } from "react";

export function useTaskState(defaultTask: TestBuyFollowUp) {
  const [task, setTask] = useState(defaultTask);
  return { task, setTask };
}
